import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "lib/apiInstance";
import { LOCAL_STORAGE } from "utils/constant";
import { BASE_URL } from "./endpoints";

export const subscriberService = createApi({
  reducerPath: "subscriberService",
  baseQuery: baseQueryWithReauth({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem(LOCAL_STORAGE.USER_TOKEN) || "";
      headers.set("Content-type", "application/json; charset=UTF-8");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["subscribers"],
  endpoints: (builder) => ({
    getSubscribersAdmin: builder.query({
      query: (params) => ({
        url: "/admin/subscriber/get",
        method: "GET",
        params,
      }),
      providesTags: ["subscribers"],
    }),
  }),
});

export const { useGetSubscribersAdminQuery } = subscriberService;
